import { useAppSelector } from '@/store/hooks';

const useIsPermissionsLoaded = (): boolean =>
  useAppSelector(state => state.tripToken.status === 'fulfilled');

export default useIsPermissionsLoaded;
